import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { setupNotificationHandlers } from './services/capacitor-notifications';

// Initialize Capacitor notification handlers
setupNotificationHandlers();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);